'use strict';

function hasTimestamp(value) {
  return value != null && value !== '';
}

/**
 * Soft-deleted trials stay in the database until the 30-day purge.
 * get-trials-by-patient used to return them with no trash flag; once a row
 * carries trashed_at / deleted_at (or an explicit trashed flag), it must not
 * appear in pickers.
 */
export function isTrashedTrial(trial) {
  if (!trial || typeof trial !== 'object') return false;
  if (hasTimestamp(trial.trashed_at) || hasTimestamp(trial.deleted_at)) return true;
  if (trial.trashed === true || trial.deleted === true) return true;
  const status = typeof trial.status === 'string' ? trial.status.trim().toLowerCase() : '';
  return status === 'trashed' || status === 'deleted';
}

export function omitTrashedTrials(payload) {
  if (!payload || typeof payload !== 'object' || !Array.isArray(payload.result)) return payload;
  return {
    ...payload,
    result: payload.result.filter((trial) => !isTrashedTrial(trial)),
  };
}
